<template>
  <div class="busi5-page busi-detail">
    <section class="banner">
      <h1>绿电低碳服务</h1>
      <p>
        九恒为客户提供智能光伏、新型储能、分布式微电网等新型电力系统解决方案和碳咨询、碳运营、碳交易、碳金融等碳中和服务。在智电运营的大数据积累之上，以一体化电碳为依托，立体化改善客户能源利用结构，助力绿色低碳转型。
        <a href="https://www.wjx.cn/vm/t9gPiBR.aspx#" target="_blank">立即咨询</a>
      </p>
    </section>
    <h2>新型电力系统服务</h2>
    <p>基于客户“低碳、高效、安全、智能、节费”的需求，为客户提供新型电力系统的综合解决方案，帮助客户实现用能系统的转型发展。</p>
    <div class="img-tab ctn">
      <ul class="tab-content">
        <li v-show="curImg === 0">
          <h3>智能光伏</h3>
          <p>提供从光伏投资、光伏设计、光伏建设到光伏运营的系统性解决方案。客户只提供场地即可享受光伏收益。</p>
        </li>
        <li v-show="curImg === 1">
          <h3>新型储能</h3>
          <p>可与光伏等新能源协调运行，应用场景多样化，可进行需求管理、峰谷套利，降低用电成本。</p>
        </li>
        <li v-show="curImg === 2">
          <h3>分布式微电网</h3>
          <p>可提供综合能源管理、灵活并网、售电代理等新型电力服务，实现绿色电能就近消纳、自发自用、节能减排，同时余电上网盈利。</p>
        </li>
        <li v-show="curImg === 3">
          <h3>光储直柔</h3>
          <p>光储直柔技术是新能源技术在建筑领域的全新应用，系统稳定性好、维护成本低，可实现新能源灵活消纳，综合降低用电成本。</p> 
        </li>
        <li v-show="curImg === 4">
          <h3>充电桩</h3>
          <p>借助先进的超充、快充与换电技术，搭配智能化的能源管理体系与运维系统，满足复合场景下的补电需求。</p>
        </li>
      </ul>
      <ul class="tab" :class="'tab-' + curImg">
        <li :class="{c: curImg === 0}" @mouseenter="curImg = 0">
          <i></i>
          <h3>智能光伏</h3>
        </li>
        <li :class="{c: curImg === 1}" @mouseenter="curImg = 1">
          <i></i>
          <h3>新型储能</h3>
        </li>
        <li :class="{c: curImg === 2}" @mouseenter="curImg = 2">
          <i></i>
          <h3>微电网</h3>
        </li>
        <li :class="{c: curImg === 3}" @mouseenter="curImg = 3">
          <i></i>
          <h3>光储直柔</h3>
        </li>
        <li :class="{c: curImg === 4}" @mouseenter="curImg = 4">
          <i></i>
          <h3>充电桩</h3>
        </li>
      </ul>
    </div>
    <h2 class="center">绿色发展解决方案</h2>
    <p class="center">针对客户不同的用能场景与需求，结合新型电力系统，给出定制化、场景化的能源利用方案。</p>
    <ul class="img">
      <li><h3>绿色园区解决方案</h3><p>利用风光热等复合型能源，降本增效</p></li>
      <li><h3>交通出行解决方案</h3><p>快充、超充、换电，覆盖新能源交通用电全场景</p></li>
      <li><h3>商业综合体解决方案</h3><p>光伏一体化+定制化储能，就近消纳，降低用能成本</p></li>
      <li><h3>大数据中心解决方案</h3><p>自主研发综合能源运管方案，降低数据中心PUE指数</p></li>
      <li><h3>发电侧解决方案</h3><p>针对发电企业的专项服务，提升能源利用效率，助力能源转型</p></li>
      <li><h3>定制储能解决方案</h3><p>发电侧、用电侧的集中储能和分布式储能，调频响应，削峰填谷</p></li>
    </ul>
    <h2>碳中和服务</h2>
    <p>九恒以新型电力技术创新研究和应用为主要抓手，以数字技术为核心路径，通过数据化分析、系统性规划、孪生化呈现、智慧化模拟、立体化治理，为政府、工业园区和企事业单位提供一体化碳中和服务。</p>
    <ul class="icon ctn">
      <li>
        <i></i>
        <h3>碳咨询与碳规划</h3>
        <p>
          碳排放数据核算<br/>
          碳排放情况分析<br/>
          碳盘查<br/>
          ……
        </p>
      </li>
      <li>
        <i></i>
        <h3>低碳履约服务</h3>
        <p>
          配额预测<br/>
          履约服务<br/>
          ……
        </p>
      </li>
      <li>
        <i></i>
        <h3>绿色资产开发</h3>
        <p>
          CCER开发咨询<br/>
          林业碳汇<br/>
          海洋碳汇<br/>
          ……
        </p>
      </li>
      <li>
        <i></i>
        <h3>碳资产管理</h3>
        <p>
          梳理碳资产架构<br/>
          碳资产增值<br/>
          风险管控<br/>
          ……
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      curImg: 0
    }
  }
}
</script>
